/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { useTranslation } from '@web/src/lib/intl/react'
import { useMemo } from 'react'
import type { PlaceCategoryEnum } from 'types/graphql'

const PLACE_CATEGORY_ORDER: readonly PlaceCategoryEnum[] = ['NUDE_BEACH', 'RESORT', 'CLUB', 'CAMPING', 'OTHER'] as const

/** i18n keys (English phrases as keys per project convention). */
const PLACE_CATEGORY_MESSAGE_KEYS: Record<PlaceCategoryEnum, string> = {
  NUDE_BEACH: 'Nude Beach',
  RESORT: 'Resort',
  CLUB: 'Club',
  CAMPING: 'Camping',
  OTHER: 'Other',
}

export function usePlaceCategoryOptions() {
  const { t } = useTranslation()

  return useMemo(
    () => ({
      selectOptions: PLACE_CATEGORY_ORDER.map((value) => ({
        value,
        label: t(PLACE_CATEGORY_MESSAGE_KEYS[value]),
      })),
      labelFor: (category: PlaceCategoryEnum) => t(PLACE_CATEGORY_MESSAGE_KEYS[category]),
    }),
    [t]
  )
}
